<template>
    <div>
        <div v-if="errorRendering" class="text-center py-4">
            <p><strong>We couldn't load this document.</strong></p>
            <p>No worries, just click the button below to open the document in a new tab.</p>
            <a :href="pdfurl" target="_blank" class="mt-2 btn btn-primary">↗ Open Document</a>

            <p class="mt-4 text-muted" v-if="helpEmailAddress">Need help? Contact us at <a :href="'mailto:' + helpEmailAddress">{{ helpEmailAddress }}</a>.</p>
        </div>
        <div :style="{width:pdf_div_width,margin:'0 auto'}">
            <canvas v-for="page in pdf_pages" :id="idPrefix + page" :key="page"></canvas>
        </div>
    </div>
</template>

<script>
import Modal from "./ModalFullScreen.vue";

let PDFJS = require('pdfjs-dist');
PDFJS.GlobalWorkerOptions.workerSrc = window.PDF_JS_WORKER;

let componentInstanceIdSequence = 0;

export default {
    name: "PdfViewer",
    components: {Modal},
    props: {
        pdfurl: {
            type: String,
        },
        helpEmailAddress: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            pdf_scale: 1.5,
            pdf_pages: [],
            pdf_div_width: '',
            errorRendering: false,

            instanceId: componentInstanceIdSequence++,
        }
    },
    computed: {
        idPrefix() {
            return 'pdf_viewer_canvas_' + this.instanceId + '_';
        }
    },
    watch: {
        pdfurl: {
            handler() {
                this.renderPdf();
            },
            immediate: true,
        }
    },

    async beforeUnmount() {
        await this._destroyCurrentPdfDocInstance();
    },

    methods: {
        async renderPdf() {
            if (this.pdfurl) {
                await this._loadFile(this.pdfurl);
            } else {
                await this._clearCanvas();
            }
        },
        async _clearCanvas() {
            await this._destroyCurrentPdfDocInstance();

            this.pdf_pages = [];
            this.pdf_div_width = '';
            this.errorRendering = false;
        },
        async _loadFile(url) {
            await this._destroyCurrentPdfDocInstance();

            try {
                this.errorRendering = false;
                let loadingTask = PDFJS.getDocument(url)
                loadingTask.promise
                    .then((pdf) => {
                        this.pdfDoc = pdf;
                        this.pdf_pages = this.pdfDoc.numPages;

                        this.$nextTick(() => {
                            this._renderPage(1)
                        })
                    }).catch((error) => {
                        this.errorRendering = true;
                        this.pdf_pages = [];
                        this.pdf_div_width = '';
                        console.error('Error loading PDF: ' + url, error);

                        try {
                            loadingTask.destroy();
                        } catch (e) {
                            console.error('Error destroying loading task', e);
                        }
                    });
            } catch(error) {
                this.errorRendering = true;
                console.error('Error initializing pdf.js ' + url, error);
            }
        },
        _renderPage(num) {  //渲染pdf页
            const that = this
            this.pdfDoc.getPage(num)
                .then((page) => {
                    let canvas = document.getElementById(this.idPrefix + num)
                    let ctx = canvas.getContext('2d')
                    let dpr = window.devicePixelRatio || 1
                    let bsr = ctx.webkitBackingStorePixelRatio ||
                        ctx.mozBackingStorePixelRatio ||
                        ctx.msBackingStorePixelRatio ||
                        ctx.oBackingStorePixelRatio ||
                        ctx.backingStorePixelRatio || 1
                    let ratio = dpr / bsr
                    let viewport = page.getViewport({scale: this.pdf_scale})
                    canvas.width = viewport.width * ratio
                    canvas.height = viewport.height * ratio
                    canvas.style.width = viewport.width + 'px'
                    that.pdf_div_width = viewport.width + 'px'
                    canvas.style.height = viewport.height + 'px'
                    ctx.setTransform(ratio, 0, 0, ratio, 0, 0)
                    let renderContext = {
                        canvasContext: ctx,
                        viewport: viewport
                    }
                    page.render(renderContext)
                    if (this.pdf_pages > num) {
                        this._renderPage(num + 1)
                    }
                }).catch((error) => {
                    this.errorRendering = true;
                    this.pdf_pages = [];
                    this.pdf_div_width = '';
                    console.error('Error rendering PDF: ' + url, error);
                });
        },

        async _destroyCurrentPdfDocInstance() {
            if (this.pdfDoc) {
                try {
                    await this.pdfDoc.destroy();
                    this.pdfDoc = null;
                } catch (error) {
                    console.error('Error destroying previous PDF: ', error);
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
</style>